import axios from 'axios';
import useAgent from '../../../hooks/useAgent';

const url = (inventoryId, itemId) => `/api/v1/inventory/${inventoryId}/inventory-items/${itemId}`;

const getItem = (inventoryId, itemId) => axios.get(url(inventoryId, itemId));

export const useGetItem = () => useAgent(getItem);

const useGetItemMovements = (inventoryId, itemId) => {
  return useAgent((params = new URLSearchParams()) => {
    return axios.get(`${url(inventoryId, itemId)}/movements`, { params });
  });
};

export { useGetItemMovements };

const getItemAgnicoEagleAssignations = (inventoryId, itemId) => axios.get(`${url(inventoryId, itemId)}/agnico-eagle/assignations`);

export const useGetItemAgnicoEagleAssignations = () => useAgent(getItemAgnicoEagleAssignations);
